import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { useI18n } from "@/lib/i18n";

const PageTitle = ({ title, subtitle, breadcrumbKey }) => {
  const { t, localePath } = useI18n();

  return (
    <section
      data-testid="page-title-banner"
      className="bg-[#0B2545] text-white border-b border-slate-800"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-20">
        <nav
          className="flex items-center gap-1.5 text-xs uppercase tracking-[0.18em] text-slate-400"
          aria-label="Breadcrumb"
        >
          <Link
            to={localePath("/")}
            data-testid="pagetitle-breadcrumb-home"
            className="hover:text-white"
          >
            {t("pageTitles.breadcrumbHome")}
          </Link>
          <ChevronRight size={12} className="text-slate-500" />
          <span className="text-slate-200" data-testid="pagetitle-breadcrumb-current">
            {t(`pageTitles.breadcrumb${breadcrumbKey.charAt(0).toUpperCase() + breadcrumbKey.slice(1)}`)}
          </span>
        </nav>
        <h1
          data-testid="pagetitle-title"
          className="mt-5 font-heading text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.05] text-white"
        >
          {title}
        </h1>
        {subtitle && (
          <p
            data-testid="pagetitle-subtitle"
            className="mt-4 max-w-3xl text-base sm:text-lg text-slate-300 leading-relaxed"
          >
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
};

export default PageTitle;
